import BaseTitle from './BaseTitle';


export default (Vue) => {
  Vue.component(BaseTitle.name, BaseTitle);
};



// WEBPACK FOOTER //
// ./src/components/common/base-title/index.js